export const setEditdata = (data) => {
    return {
      type: 'SET_EDIT_DATA',
      payload: data
    };
  };